import { Features } from '@/utils/Features'

const STORAGE_KEY = 'hedvig:bankid-sandbox'

const listeners = new Set<() => void>()

// Backend only honours the sandbox on staging, so this choice has no effect elsewhere
export function getIsBankIdSandboxSelected() {
  if (!Features.enabled('BANKID_SANDBOX')) return false
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function setIsBankIdSandboxSelected(isSelected: boolean) {
  try {
    if (isSelected) {
      window.localStorage.setItem(STORAGE_KEY, 'true')
    } else {
      window.localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    // Storage can be blocked, the sandbox then stays off
  }
  listeners.forEach((listener) => listener())
}

export function subscribeToBankIdSandbox(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
